<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/establish/fddetail',title:'返利管理'},{title:'返利发票数据明细'}]"/>-->
    <Breadtabsheader/>
    <div class="h-content">

      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="签收月" class="nianboxs" prop="startCdate">
                <el-date-picker
                    :clearable="false"
                    v-model="q.startCdate"
                    type="month"
                    value-format="yyyy-MM"
                    placeholder="--签收月份--">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="返利链群" prop="contractId">
                <brselect category="fl_contract_type_main" :v="q.contractId" v-model="q.contractId" :clearable="true"/>
              </el-form-item>
              <el-form-item label="销售订单号" prop="aupos">
                <el-input v-model="q.aupos" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="经销商" prop="kunrgLike">
                <el-input v-model="q.kunrgLike" placeholder="请输入编码或名称"></el-input>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="传统产业" prop="belongIndustry">
                    <brselect category="fl_belong_industry" :v="q.belongIndustry" v-model="q.belongIndustry" :clearable="true" :multiple="true"/>
                  </el-form-item>
                  <el-form-item label="渠道" prop="channelCode">
                    <brselect category="fl_sales_region_qudao" :v="q.channelCode" v-model="q.channelCode" :clearable="true" :multiple="true"/>
                  </el-form-item>
                  <el-form-item label="经销商类型" prop="channelCode">
                    <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                <el-button @click="qingkong" class="h-btn h-formBtn"
                           style="background-color:white;color:black;border:1px solid #d1d1d1">重置
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>


      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table
            ref="ddtable"
            :data="tableData"
            stripe
            style="width: 100%"
        >
          <el-table-column
              prop="erdat"
              :show-overflow-tooltip="true"
              label="签收日期"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="区域"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="kunrg"
              :show-overflow-tooltip="true"
              label="客户编码"
              width="160"
          >
          </el-table-column>
          <el-table-column
              prop="kunrgT"
              :show-overflow-tooltip="true"
              label="客户名称"
              width="210"
          >
          </el-table-column>
          <el-table-column
              prop="lianqun"
              :show-overflow-tooltip="true"
              label="链群"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="belongIndustry"
              :show-overflow-tooltip="true"
              label="产业"
              width="120"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.contractId == 1">{{ scope.row.belongIndustry | dictname('fl_belong_industry') }}</div>
              <div v-if="scope.row.contractId != 1">{{ scope.row.contractId | dictname('fl_contract_type_main') }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="channelCode"
              :show-overflow-tooltip="true"
              label="渠道"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="aupos"
              :show-overflow-tooltip="true"
              label="销售订单号"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="wrbtr"
              :show-overflow-tooltip="true"
              label="订单金额（含税）"
              width="160"
          >
          </el-table-column>
          <el-table-column
              prop="zp00"
              :show-overflow-tooltip="true"
              label="内销基准价"
              width="160"
          >
          </el-table-column>
          <el-table-column
              prop="materialGroup3"
              :show-overflow-tooltip="true"
              label="是否计算销额"
              width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.materialGroup3 | dictname('xiaoe_jishu') }}
            </template>
          </el-table-column>
          <el-table-column
              prop="materialGroup4"
              :show-overflow-tooltip="true"
              label="是否计算基数"
              width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.materialGroup4 | dictname('xiaoe_jishu') }}
            </template>
          </el-table-column>
          <el-table-column
              prop="matnr"
              :show-overflow-tooltip="true"
              label="物料编码"
              width="140"
          >
          </el-table-column>
          <el-table-column
              prop="maktx"
              :show-overflow-tooltip="true"
              label="物料描述"
              width="170"
          >
          </el-table-column>
          <el-table-column
              prop="fkimg"
              :show-overflow-tooltip="true"
              label="物料数量"
              width="100"
          >
          </el-table-column>
          <el-table-column
              prop="aubel"
              :show-overflow-tooltip="true"
              label="sap订单号"
              width="140"
          >
          </el-table-column>
          <el-table-column
              prop="vbeln"
              :show-overflow-tooltip="true"
              label="发票号"
              width="140"
          >
          </el-table-column>
          <el-table-column
              prop="fkartT"
              :show-overflow-tooltip="true"
              label="发票类型"
              width="120">
          </el-table-column>
          <el-table-column
              prop="vkorg"
              :show-overflow-tooltip="true"
              label="销售组织"
              width="120">
          </el-table-column>
        </el-table>

        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'


export default {
  components: {
    uploaddownexcel,
  },
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      //查询属性
      q: {
        startCdate: this.riqi(),
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      //表格
      multipleSelection: [],

      //table列表
      tableData: [],
    }
  },
  created() {
    this.q.startCdate = this.riqi();
    this.query();
  },
  methods: {
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    riqi(){
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
      var allData = year + "-" + month;
      return allData;
    },
    //重置
    qingkong() {
      this.q = {
        startCdate : this.riqi(),
        contractId :'',
        aupos :'',
        kunrgLike :'',
        belongIndustry :'',
        channelCode :'',
        agentType :'',
        pageSize: 10,
        pageNo: 1,
        total: 0,
      }
      this.query();
    },
    query() {
      ss.fanli.flInvoiceInfoPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    //勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //批量导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/demo/newEtBilling/downloadFlInvoiceExcel", this.q, "post");
    },
  }
}
</script>

<style scoped>

</style>
<style>
.el-date-editor .el-range-separator {
  width: 8%;
}
</style>
